import { getEnvConfig } from 'utils/getEnvConfig'
import { CL_VERSIONS } from 'utils/common/common.types'
import {
  ExternalBillReqPayload,
  FetchOrdersApiResponse,
  OrdersResponse
} from 'state/new-summary/orders/orders.types'
import { SaleAllocationsResponse, SaleAssignmentsResponse } from 'state/new-summary/list/list.types'
import { TemplateResponseType } from 'state/new-summary/outstandingReport/outstandingReport.types'
import { IKeyVals } from 'state/tags/tags.types'
import {
  FETCH_INVENTORY_ITEMS_RESPONSE,
  PORTAL_BRAND_ITEMS_MAPPING
} from 'services/Api/BillingApiFolder.ts/type'
import { InventoryItemUploadType } from 'state/billing/billing.types'
import {
  BRAND_ACTION_ENUM,
  IBrandProductMapping,
  IBrandSaleSummary
} from 'state/new-summary/brand/brand.types'
import {
  FilterEntityEnum,
  IFilterByLabelKeyPayload
} from 'state/new-summary/root-drawers/tag-filter/tag-filter.types'
import {
  IOverallSalesOrder,
  ISalesAnalyticsItemLevelData
} from 'state/new-summary/supply/supply.types'
import ApiService from '../ApiService'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from '../apiInterceptor'
import { API_RESPONSE_TYPE, IApiResponse } from '../../../constants'
import {
  BUSINESS_CONFIG_RESPONSE,
  BankWiseApiPayload,
  BankWiseResponse,
  CREATE_LIST_RESPONSE,
  CREATE_LIST_V2_RESPONSE,
  FETCH_ACCOUNT_RECEIVABLES_RESPONSE,
  FETCH_COLLECTION_LIST_V2_RESPONSE,
  FETCH_GROUP_ACCOUNTS_SUMMARY_RESPONSE,
  FETCH_LIST_API_RESPONSE,
  FETCH_OVERALL_ACCOUNTS_SUMMARY_RESPONSE,
  FETCH_PERMISSION_RESPONSE,
  FILTER_OPTION,
  FetchCustomerProfilesAPIPayload,
  IAutoAssignConfig,
  IFetchSalesOrderPayload,
  LIST_USAGE_TYPE,
  ListCatalogueItemsPayload,
  SaleAllocationApiAction,
  UPDATE_BILL_AMOUNT_RESPONSE,
  UpdateOrderApiPaylod,
  UpdateProformaStatusApiPaylod,
  fetchOrdersPayload
} from './type'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

let endpoint: string = ''
if (typeof window !== 'undefined') {
  if (window.location.origin.toString().includes('localhost')) {
    endpoint = getEnvConfig('STAFF_LINK_BASE_URL') || ''
  } else {
    endpoint = `${window.location.origin}/api/staff-link`
  }
}

const api = new ApiService(endpoint, headers)
api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

const FETCH_COLLECTION_LIST_V2 = '/v2/GetCollectionListBillDetails'
const BULK_CANCEL_INVOICE = '/v1/bills/bulk-cancel'
const CREATE_LIST_V2 = '/v2/CreateCollectionListOfBills'
const CREATE_LIST = '/v1/CreateCollectionList'
const GET_BILLS_BY_TAGS = 'v1/FilterBillsByTags'
const UPDATE_LIST = '/v1/UpdateCollectionList'
const UPDATE_LIST_V2 = '/v2/UpdateCollectionListOfBills'
const FETCH_LIST = '/v3/GetCL'
const UPDATE_MULTIPLE_TRANSACTION = '/v1/UpdateMultipleTransactions?updated_by=accountant'
const STAFF_ACCESS_LIST = '/v1/ListStaffAccess'
const ALL_CUSTOMER_PROFILES = '/v1/ListCustomerProfiles'
const UPDATED_BILL_AMOUNT = '/web/v1/update-bill-amount'
const CASH_BY_STAFF_BANK_WISE = '/v1/BankwiseReport'
const FETCH_ORDERS = '/web/orders/v1/GetOrders'
const UPDATE_ORDERS = '/web/orders/v1/UpdateOrder'
const UPDATE_MULTIPLE_ORDERS = '/web/orders/v1/UpdateMultipleOrders'
const LIST_CATALOGUE_ITEMS = '/web/orders/v1/ListInventoryItems'
const CREATE_ORDER_BILL = '/web/orders/v1/CreateBill'
const CREATE_ORDER_PROFORMA = '/web/orders/v1/CreateProformaInvoice'
const CREATE_ORDER_PROFORMA_SETTLEMENT = '/web/orders/v1/CreateProformaInvoiceSettlement'
const UPDATE_PROFORMA_STATUS = '/web/orders/v1/UpdateProformaInvoiceStatus'

const USER_PERMISSIONING = '/permissions/v1/UserPermissions'
const GET_SELECTED_ORDER_SETTING_ACCOUNT_IDS = '/web/orders/v1/cl/setting/accounts/list'
const ADD_SELECTED_ORDER_SETTING_ACCOUNT_IDS = '/web/orders/v1/cl/setting/accounts'
const DESELECT_ORDER_SETTING_ACCOUNT_IDS = '/web/orders/v1/cl/setting/accounts/inactive'
const GET_SELECTED_ORDER_SETTING_INVENTORY_IDS = '/web/orders/v1/cl/setting/inv-items/list'
const ADD_ELIGIBLE_ORDER_SETTING_INVENTORY_IDS = '/web/orders/v1/cl/setting/inv-items'
const REMOVE_INACTIVE_ORDER_SETTING_INVENTORY_IDS = '/web/orders/v1/cl/setting/inv-items/inactive'
const FETCH_ACTIVE_SALE_ASSIGNMENT = '/v1/sale-assignment'
const CREATE_SALE_ASSIGNMENT = '/v1/sale-assignment'
const CREATE_SALE_ALLOCATION = '/v1/sale-assignment/allocations'
const DELETE_SALE_ASSIGNMENT = '/v1/sale-assignment'
const UPDATE_SALE_ALLOCATION = '/v1/sale-assignment/allocations'
const FETCH_SALE_ALLOCATION = '/v1/sale-assignment/allocations'
const EXTERNAL_BILL_CREATE = '/web/orders/v1/CreateExtBill'

const FETCH_LIST_BILLS = '/v1/ListPendingBills'
const UPLOAD_OUTSTANDING_REPORT_FILE = '/external/documents/outstandingBills'
const GET_DOCUMENT_STATUS = '/external/document/status'
const GET_ALL_UPLOADED_OUTSTANDING_REPORTS = '/external/documents'
const CREATE_ERROR_FILE = '/external/document/errorFile'
const GET_ERROR_FILE = '/external/document/errorFile/download'
const DOCUMENT_ERRORS = '/external/document/errors'
const TEMPLATE = 'external/document/template'
const ACCOUNT_RECEIVABLES_ERROR = '/arReport/unlistedInvoiceErrors?doc_id='
const FILTER_BY_LABEL_KEY = '/v1/FilterEntityByLabelKeyVals'

// Order Summary
const GET_OVERALL_GROUP_SUMMARY = '/web/v2/order-summary-item-level'
const GET_OVERALL_GROUP_OUTER_DATA = '/web/v2/overall-order-summary'
// Global calls
const GET_BUSINESS_LABEL_KEY_VALUE = '/web/v1/GetBusinessLabelsKeyVals'
const GET_ENTITY_BY_KEY_ID = '/web/v1/GetLabelValsByEntityAndKeyId'

// Inventory Apis
const LIST_INVENTORY_ITEMS = '/web/v1/ListInventoryItems'
const PORTAL_BRAND_ITEMS_MAPPER = '/web/v1/ListBusinessInvItemsBrandDetails'
const BLOCK_ITEMS = '/web/v1/UpdateInventoryBlockedQtyForOrder'
const UNBLOCK_ITEMS = '/web/v1/UpdateInventoryBlockedQtyForOrder'
const UPDATE_LABEL_INVENTORY_CATEGORY = '/web/v1/LabelInventoryItemCategory'
const UPLOAD_INVENTORY_ITEMS = '/web/v1/UploadInventory'

// Business Config
const GET_BUSINESS_CONFIG = '/v1/profile/GetDistributorInfo'
const UPDATE_BUSINESS_CONFIG = '/v1/profile/UpdateDistributorInfo'

// Brand Summary
const GET_BRAND_SUMMARY = '/brand/v1/GetBrandSaleSummary'
const GET_BRAND_PRODUCT_MAPPING = '/brand/v1/ListBrandProducts'
const UPLOAD_BRAND_PRODUCT_MAPPING = '/brand/v1/BrandProductUpload'
const GET_BRAND_REPORT = '/brand/v1/BrandSalesReportsOfDistributor'
const UPDATE_ORDER_QUANTITY = '/web/orders/v1/UpdateOrder'

// STAFF GROUP
const CREATE_STAFF_GROUP = '/v1/staffs/add-parent'
const ADD_STAFF = '/v1/staffs/create'
// Sales Order Apis
const FETCH_OVERALL_SALES_ORDER = '/v1/BusinessSalesSummary/Overall'
const FETCH_ITEM_LEVEL_SALES_ORDER = '/v1/BusinessSalesSummary/ItemLevel'

export const fetchUserPermission = (payload: {
  user_id: string
}): Promise<IApiResponse<FETCH_PERMISSION_RESPONSE>> => {
  return Promise.resolve({
    data: {
      user_id: payload.user_id,
      business_id: '',
      permitted_workflows: [],
      non_permitted_workflows: []
    },
    type: API_RESPONSE_TYPE.SUCCESS
  })
}

export const createStaffGroup = (payload: { parent_staff_id: string; staff_ids: string[] }) => {
  return api.postRequest(CREATE_STAFF_GROUP, payload)
}

export const addNewStaff = (payload: { name: string; mobile: string }) => {
  return api.postRequest(ADD_STAFF, payload)
}

export const getBusinessConfig = (payload?: {
  logged_in_user_id?: string
}): Promise<IApiResponse<BUSINESS_CONFIG_RESPONSE>> => {
  return {
    data: [],
    type: API_RESPONSE_TYPE.SUCCESS
  }
}

export const getBrandProfile = () => {
  return api.getRequest('/brand/v1/GetBrandProfile', {})
}

export const updateBusinessConfig = (payload: {
  pan_number?: string
  branch?: string
  zone?: string
  region?: string
  billing_software?: string
}) => {
  return api.postRequest(UPDATE_BUSINESS_CONFIG, { distributor_info: payload })
}

export const fetchAccountReceivablesErrorApi = (payload: {
  docId: string
}): Promise<IApiResponse<FETCH_ACCOUNT_RECEIVABLES_RESPONSE>> => {
  return api.getRequest(ACCOUNT_RECEIVABLES_ERROR + payload.docId, {})
}

export const fetchBillsDetailsApi = ({
  startTime,
  endTime,
  billType
}: {
  startTime?: number
  endTime?: number
  billType?: 0 | 1 | number
}) => {
  const url =
    `${FETCH_LIST_BILLS}?page=1&per_page=9999999` +
    (startTime || startTime === 0 ? `&start_time=${startTime}` : '') +
    (endTime || endTime === 0 ? `&end_time=${endTime}` : '') +
    (billType || billType === 0 ? `&filter=${billType}` : '')
  return api.getRequest(url, {})
}

export const fetchList = (
  listId: string,
  version?: CL_VERSIONS
): Promise<IApiResponse<FETCH_LIST_API_RESPONSE>> => {
  return api.postRequest(FETCH_LIST, {
    list_id: listId,
    ...((version || version === CL_VERSIONS.PREVIOUS_ASSIGNMENT) && { version })
  })
}

/** To Remove this API once, new API is integrated */
export const fetchSingleCollectionListV2Api = (
  businessId: string,
  collectionListId: string,
  version: CL_VERSIONS
): Promise<IApiResponse<FETCH_COLLECTION_LIST_V2_RESPONSE>> => {
  return api.postRequest(`${FETCH_COLLECTION_LIST_V2}`, {
    business_id: businessId,
    collection_list_id: collectionListId,
    version
  })
}

export const bulkCancelInvoiceReq = (
  billIds: string[]
): Promise<
  IApiResponse<{
    errors: any[]
    message: 'SUCCESS' | 'FAILURE'
    status: '200' | string
  }>
> => {
  return api.postRequest(BULK_CANCEL_INVOICE, { bill_ids: billIds })
}

export const createNewListV2Api = (payload: {
  name: string
  bills: {
    bill_id: string
    customer_id: string
  }[]
  due_config: {
    config: number
  }
  usage_type: number
}): Promise<IApiResponse<CREATE_LIST_V2_RESPONSE>> => {
  return api.postRequest(CREATE_LIST_V2, payload)
}

export const createNewList = (payload: {
  name: string
  associated_account_ids: string[]
  due_config: {
    config: number
  }
  usage_type: number
}): Promise<IApiResponse<CREATE_LIST_RESPONSE>> => {
  return api.postRequest(CREATE_LIST, payload)
}

export const fetchBillsByTags = (payload: {
  tag_ids: string[]
  filter_option: FILTER_OPTION
}): Promise<
  IApiResponse<{
    bill_ids: string[]
  }>
> => {
  return api.postRequest(GET_BILLS_BY_TAGS, payload)
}

export const updateListV2 = (payload: {
  collection_list: {
    id: string
    name?: string
    usage_type?: LIST_USAGE_TYPE
    associated_account_ids?: string[] | undefined
    bills?: { bill_id: string; customer_id: string }[] | undefined
    business_id?: string
    due_config?: {
      config: number
    }
    auto_assign_config?: IAutoAssignConfig[]
    settings?: {
      all_pending_invoices?: boolean
    }
  }
  action:
    | 'add_bills'
    | 'remove_bills'
    | 'replace_bills'
    | 'due_config'
    | 'move_bills'
    | 'edit_name2'
    | 'update_filters'
    | 'mark_inactive'
    | 'update_usage_type'
    | 'update_settings'
}): Promise<IApiResponse<FETCH_COLLECTION_LIST_V2_RESPONSE>> => {
  return api.postRequest(UPDATE_LIST_V2, payload)
}

export const updateList = (payload: {
  collection_list: {
    id: string
    associated_account_ids: string[]
  }
  action: 'edit_associations' | 'remove_associations'
}) => {
  return api.postRequest(UPDATE_LIST, payload)
}

export const approveBulkCollectionStaffLinkV2 = (
  transactions: Array<{
    id: string
    business_id: string
    approved_by_merchant: boolean
  }>
) => {
  return api.putRequest(UPDATE_MULTIPLE_TRANSACTION, {
    transactions
  })
}

export const deleteBulkTransactions = (
  transactions: Array<{
    id: string
    business_id: string
    is_deleted: boolean
  }>
) => {
  return api.putRequest(UPDATE_MULTIPLE_TRANSACTION, {
    transactions
  })
}

export const moveList = (payload: {
  collectionListId: string
  accountIds: string[]
  targetCollectionListId: string
}) => {
  return api.postRequest(UPDATE_LIST, {
    collection_list: {
      id: payload.collectionListId,
      associated_account_ids: payload.accountIds
    },
    action: 'move_associated_accounts',
    target_collection_list_id: payload.targetCollectionListId
  })
}

export const moveListV2 = (payload: {
  collectionListId: string
  bills: { bill_id: string; customer_id: string }[]
  targetCollectionListId: string
}) => {
  return api.postRequest(UPDATE_LIST_V2, {
    collection_list: {
      id: payload.collectionListId,
      bills: payload.bills
    },
    action: 'move_bills',
    target_collection_list_id: payload.targetCollectionListId
  })
}

export const getStaffAccessListApi = (payload: {
  staffUid?: string
  collectionListId?: string
}) => {
  const { staffUid, collectionListId } = payload
  const queryParams = new URLSearchParams()
  if (staffUid) {
    queryParams.append('staff_uid', staffUid)
  }
  if (collectionListId) {
    queryParams.append('resource_id', collectionListId)
  }
  const url = STAFF_ACCESS_LIST + (queryParams.toString() ? `?${queryParams.toString()}` : '')
  return api.getRequest(url, {})
}

export const getAllCustomerProfilesApi = (payload: FetchCustomerProfilesAPIPayload) => {
  return api.postRequest(ALL_CUSTOMER_PROFILES, payload)
}

export const updateBillAmount = ({
  billId,
  amountInPaisa,
  billVersion
}: {
  billId: string
  amountInPaisa: number
  billVersion: number
}): Promise<IApiResponse<UPDATE_BILL_AMOUNT_RESPONSE>> => {
  return api.postRequest(UPDATED_BILL_AMOUNT, {
    bill_id: billId,
    amount: amountInPaisa,
    bill_version: billVersion
  })
}

export const getBankWiseSummaryApi = (
  payload: BankWiseApiPayload
): Promise<IApiResponse<BankWiseResponse>> => {
  return api.postRequest(CASH_BY_STAFF_BANK_WISE, payload)
}

export const fetchOrdersApi = (
  payload: fetchOrdersPayload
): Promise<IApiResponse<FetchOrdersApiResponse>> => {
  return api.postRequest(FETCH_ORDERS, payload)
}

export const updateOrdersApi = (
  payload: UpdateOrderApiPaylod
): Promise<IApiResponse<OrdersResponse>> => {
  return api.putRequest(UPDATE_ORDERS, payload)
}

export const updateProformaStatusApi = (payload: UpdateProformaStatusApiPaylod) => {
  return api.postRequest(UPDATE_PROFORMA_STATUS, payload)
}

export const updateMultipleOrdersApi = (
  payload: Array<UpdateOrderApiPaylod>
): Promise<IApiResponse<Array<UpdateOrderApiPaylod>>> => {
  return api.putRequest(UPDATE_MULTIPLE_ORDERS, { update_orders: payload })
}

export const listCatalogueItemsApi = (
  payload: ListCatalogueItemsPayload
): Promise<IApiResponse<any>> => {
  return api.postRequest(LIST_CATALOGUE_ITEMS, payload)
}

export const createOrderBillApi = (payload: any): Promise<IApiResponse<any>> => {
  return api.postRequest(CREATE_ORDER_BILL, payload)
}

export const createOrderProformaApi = (payload: any): Promise<IApiResponse<any>> => {
  return api.postRequest(CREATE_ORDER_PROFORMA, payload)
}

export const createOrderProformaSettlementApi = (payload: any): Promise<IApiResponse<any>> => {
  return api.postRequest(CREATE_ORDER_PROFORMA_SETTLEMENT, payload)
}

export const fetchSelectedOrderSettingAccountIds = (listId: string): Promise<IApiResponse<any>> => {
  return api.postRequest(GET_SELECTED_ORDER_SETTING_ACCOUNT_IDS, {
    list_id: listId
  })
}
export const addSelectedOrderSettingAccountIds = (
  listId: string,
  accountIds: string[]
): Promise<IApiResponse<any>> => {
  return api.postRequest(ADD_SELECTED_ORDER_SETTING_ACCOUNT_IDS, {
    list_id: listId,
    account_ids: accountIds
  })
}

export const deSelectedOrderSettingAccountIds = (
  listId: string,
  accountIds: string[]
): Promise<IApiResponse<any>> => {
  return api.postRequest(DESELECT_ORDER_SETTING_ACCOUNT_IDS, {
    list_id: listId,
    account_ids: accountIds
  })
}

export const uploadOutstandingReportFileReq = (payload: {
  document: number[]
  document_extension: string
  business_id: string
  file_name: string
}) => {
  return api.postRequest(UPLOAD_OUTSTANDING_REPORT_FILE, payload)
}

export const getAllUploadOutstandingReports = (
  page: number = 1,
  limit?: number,
  file_kind?: number
) => {
  // let queryParam = `page=${page}&per_page=${limit || 10}`
  // if (file_kind) {
  //   queryParam = queryParam + `&file_kind=${file_kind}`
  // }
  const queryParam = `file_kind=${file_kind}`
  return api.getRequest(`${GET_ALL_UPLOADED_OUTSTANDING_REPORTS}?${queryParam}`, {})
}

export const getDocumentStatus = (documentId: string) => {
  return api.getRequest(`${GET_DOCUMENT_STATUS}?document_id=${documentId}`, {})
}

export const getDocumentErrorsApi = (payload: { documentId: string }) => {
  const { documentId } = payload
  return api.getRequest(`${DOCUMENT_ERRORS}?doc_id=${documentId}`, {})
}

export const getDocumentErrorFile = (errorDocumentId: string) => {
  return api.getRequest(
    `${GET_ERROR_FILE}?error_document_id=${errorDocumentId}`,
    {},
    {},
    { responseType: 'arraybuffer' }
  )
}

export const createDocumentErrorFile = (documentId: string) => {
  return api.getRequest(`${CREATE_ERROR_FILE}?document_id=${documentId}`, {})
}

export const getDocumentTemplate = (): Promise<
  IApiResponse<{ template: TemplateResponseType }>
> => {
  return api.getRequest(TEMPLATE, {})
}

export const fetchSelectedOrderSettingInventoryIds = (
  listId: string
): Promise<IApiResponse<any>> => {
  return api.postRequest(GET_SELECTED_ORDER_SETTING_INVENTORY_IDS, {
    list_id: listId
  })
}

export const addEligibleInventoryItems = (payload: {
  inventory_item_ids: string[]
  list_id: string
}): Promise<IApiResponse<any>> => {
  return api.postRequest(ADD_ELIGIBLE_ORDER_SETTING_INVENTORY_IDS, payload)
}

export const removeEligibleInventoryItems = (payload: {
  inventory_item_ids: string[]
  list_id: string
}): Promise<IApiResponse<any>> => {
  return api.postRequest(REMOVE_INACTIVE_ORDER_SETTING_INVENTORY_IDS, payload)
}

export const fetchActiveSaleAllocationsApi = (
  listId: string,
  startTime: number,
  endTime: number
): Promise<IApiResponse<{ sale_assignments: SaleAssignmentsResponse[] }>> => {
  return api.getRequest(FETCH_ACTIVE_SALE_ASSIGNMENT, {
    list_id: listId,
    start_time: startTime,
    end_time: endTime
  })
}

export const createNewSaleAssignmentApi = (
  listId: string,
  startTime: number,
  businessId: string
): Promise<IApiResponse<{ sale_assignments: SaleAssignmentsResponse[] }>> => {
  return api.postRequest(CREATE_SALE_ASSIGNMENT, {
    list_id: listId,
    start_time: startTime,
    business_id: businessId
  })
}

export const createNewSaleAllocationApi = (payload: {
  allocations: {
    inventory_item_id: string
    allocated_quantity: number
  }[]
  sale_assignment_id: string
  business_id: string
}): Promise<IApiResponse<{ sale_allocations: SaleAllocationsResponse[] }>> => {
  return api.postRequest(CREATE_SALE_ALLOCATION, payload)
}

export const deleteSaleAssignmentApi = (sale_assignment_id: string): Promise<IApiResponse> => {
  return api.putRequest(DELETE_SALE_ASSIGNMENT, {
    sale_assignment_id,
    status: 3
  })
}

export const updateSaleAllocationApi = (payload: {
  allocations: {
    inventory_item_id: string
    allocated_quantity: number
  }[]
  sale_assignment_id: string
  business_id: string
  action: SaleAllocationApiAction
}): Promise<IApiResponse<{ sale_allocations: SaleAllocationsResponse[] }>> => {
  return api.putRequest(UPDATE_SALE_ALLOCATION, payload)
}

export const getSaleAllocationByIdApi = (
  id: string
): Promise<IApiResponse<{ sale_allocations: SaleAllocationsResponse[] }>> => {
  return api.getRequest(FETCH_SALE_ALLOCATION, { sale_assignment_id: id })
}

export const createExtBillApi = (payload: ExternalBillReqPayload): Promise<IApiResponse<any>> => {
  return api.postRequest(EXTERNAL_BILL_CREATE, payload)
}

export const getOverallOrderSummaryGroupApi = (payload: {
  from_date: number
  to_date: number
  page?: number
  limit?: number
}) => {
  return api.getRequest(GET_OVERALL_GROUP_SUMMARY, payload)
}

export const getOverallOrderOuterSummaryApi = (payload: { from_date: number; to_date: number }) => {
  return api.getRequest(GET_OVERALL_GROUP_OUTER_DATA, payload)
}

export const getBusinessLabelsKeyValApi = (): Promise<IApiResponse<{ key_vals: IKeyVals[] }>> => {
  return {
    data: [],
    type: API_RESPONSE_TYPE.SUCCESS
  }
}

export const getEntityByKeyId = (payload: {
  entity: FilterEntityEnum
  key_id: string
}): Promise<
  IApiResponse<{
    vals: { entity_id: string; val_ids: string[] }[]
  }>
> => {
  return api.postRequest(GET_ENTITY_BY_KEY_ID, payload)
}

// Fetch inventory items
export const fetchInventoryItems = (): Promise<IApiResponse<FETCH_INVENTORY_ITEMS_RESPONSE>> => {
  return api.getRequest(LIST_INVENTORY_ITEMS, {})
}

export const fetchPortalBrandItemMapper = (): Promise<IApiResponse<PORTAL_BRAND_ITEMS_MAPPING>> => {
  return api.postRequest(PORTAL_BRAND_ITEMS_MAPPER, { inventory_item_ids: [] }) // empty array resembles all data
}

export const blockInventoryItem = ({ orderId }: { orderId: string }): Promise<IApiResponse> => {
  return api.postRequest(BLOCK_ITEMS, {
    order_id: orderId,
    action: 1
  })
}
export const unblockInventoryItem = ({ orderId }: { orderId: string }): Promise<IApiResponse> => {
  return api.postRequest(UNBLOCK_ITEMS, {
    order_id: orderId,
    action: 2
  })
}

export const updateLabelInventoryItemCategoryApi = (payload: {
  inv_id: string
  categories: string[]
}): Promise<IApiResponse<any>> => {
  return api.postRequest(UPDATE_LABEL_INVENTORY_CATEGORY, payload)
}

export const uploadInventoryItemsApi = (payload: InventoryItemUploadType['formData']) => {
  return api.postRequest(UPLOAD_INVENTORY_ITEMS, payload, {
    'Content-Type': 'multipart/form-data'
  })
}

export const getBrandSummaryApi = (payload: {
  from_date: number
  to_date: number
}): Promise<IApiResponse<{ summary: IBrandSaleSummary[] }>> => {
  return api.getRequest(GET_BRAND_SUMMARY, payload)
}

export const getBrandProductMappingApi = (): Promise<IApiResponse<IBrandProductMapping>> => {
  return api.getRequest(GET_BRAND_PRODUCT_MAPPING, {})
}

export const uploadBrandProductMappingApi = (payload: FormData) => {
  return api.postRequest(UPLOAD_BRAND_PRODUCT_MAPPING, payload, {
    'Content-Type': 'multipart/form-data'
  })
}

export const getBrandReportApi = (payload: {
  from_date: number
  to_date: number
  format: BRAND_ACTION_ENUM
  distributor_id?: string
  brand_id?: string
  filters?: {
    distributor_ids?: string[]
    brand_inv_ids?: string[]
  }
  page: number
  per_size: number
}): Promise<IApiResponse<{ summary: IBrandSaleSummary[] }>> => {
  return api.postRequest(GET_BRAND_REPORT, payload)
}

export const downloadBrandReportApi = (payload: {
  from_date: number
  to_date: number
  format: BRAND_ACTION_ENUM
  distributor_id?: string
  brand_id?: string
}): Promise<IApiResponse<{ summary: IBrandSaleSummary[] }>> => {
  return api.postRequest(GET_BRAND_REPORT, payload, {
    responseType: 'blob' // This ensures the response is treated as a Blob
  })
}

export const filterByLabelKeyApi = (
  payload: IFilterByLabelKeyPayload
): Promise<IApiResponse<any>> => {
  return api.postRequest(FILTER_BY_LABEL_KEY, payload)
}

export const editOrderQuantityApi = (payload: {}): Promise<IApiResponse<any>> => {
  return api.putRequest(UPDATE_ORDER_QUANTITY, payload)
}

export const getOverallSalesOrderSummaryApi = (
  payload: IFetchSalesOrderPayload
): Promise<IApiResponse<IOverallSalesOrder>> => {
  return api.postRequest(FETCH_OVERALL_SALES_ORDER, payload)
}

export const fetchInnerSalesAnalyticsApi = (
  payload: IFetchSalesOrderPayload
): Promise<IApiResponse<ISalesAnalyticsItemLevelData>> => {
  return api.postRequest(FETCH_ITEM_LEVEL_SALES_ORDER, payload)
}

export const getStaffLocationLogs = (staffId: string, startTime: number, endTime: number) => {
  return api.postRequest('/staff/v1/GetLocationLogs', {
    staff_id: staffId,
    start_time: startTime,
    end_time: endTime
  })
}

export const fetchAccountSummary = (payload: {
  start_date: number
  end_date: number
}): Promise<IApiResponse<FETCH_OVERALL_ACCOUNTS_SUMMARY_RESPONSE>> => {
  return api.postRequest('/v1/AccountsSummary/Overall', payload)
}

export const fetchSpecificAccountSummary = (payload: {
  group_id: string
  start_date: number
  end_date: number
}): Promise<IApiResponse<FETCH_GROUP_ACCOUNTS_SUMMARY_RESPONSE>> => {
  return api.postRequest('/v1/AccountsSummary/Transactions', payload)
}

export const getCheckInsRecords = (params: {
  startTime: number
  endTime: number
  staffIds?: string[]
}) => {
  const { startTime, endTime, staffIds } = params
  const payload: any = {
    start_time: startTime,
    end_time: endTime
  }

  if (staffIds) {
    payload.staff_ids = staffIds
  }

  return api.postRequest('/staff/v1/GetCheckIns', payload)
}
